export class DashboardSearchNavItem {
    name: string;
    actionRef: string;
    icon: string;
    searchTags: string[];
}
